<template>
  <side-bar
    v-show="isSidebarActiveLocal"
    position-right
    class="z-10 max-w25 cust-overflow-y-primary-color"
  >
    <div
      class="flex  sidebar-topfixpart bg-primary justify-between p-4 add-sidebar-top"
    >
      <h2 class="h2-class font-semibold text-white ">
        ADD STORE
      </h2>

      <feather-icon
        icon="XIcon"
        @click="isSidebarActiveLocal = false"
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
    </div>
    <div class="px-4 pt-20 pb-12">
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Store Name</p>
        <b-input placeholder="Enter  Name..." />
      </div>
      <!-- <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Store Shop Name</p>
        <b-input placeholder="Enter  Name..." />
      </div> -->

      <div class="flex mb-4">
        <div class="pr-3 w-1/2">
          <p class="font-semibold text-sm mb-2">Email ID</p>
          <b-input placeholder="Enter  EmailID..." />
        </div>
        <div class="pl-2 w-1/2">
          <p class="font-semibold text-sm mb-2">Mobile</p>
          <b-input placeholder="Enter  Mobile..." />
        </div>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Address</p>
        <b-input placeholder="Enter  Address..." />
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Date</p>
        <!-- <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"
                ><i class="ni ni-calendar-grid-58"></i
              ></span>
            </div>
            <input
              class="form-control datepicker"
              placeholder="Select date"
              type="text"
              value="13/07/2021"
            />
          </div>
        </div> -->
        <!-- <div>
          <label for="example-datepicker">Choose a date</label>
          <b-form-datepicker
            id="example-datepicker"
            v-model="value"
            class="mb-2"
          ></b-form-datepicker>
          <p>Value: '{{ value }}'</p>
        </div> -->
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"
                ><i class="ni ni-calendar-grid-58"></i
              ></span>
            </div>
            <input
              class="form-control datepicker"
              placeholder="Select date"
              type="text"
              value="06/20/2020"
            />
          </div>
        </div>
      </div>
      <div class="mb-4 flex">
        <div class="pr-2 w-1/2">
          <p class="font-semibold text-sm mb-2">City</p>

          <b-input placeholder="Enter  City..." />
        </div>

        <div class="pl-2 w-1/2">
          <p class="font-semibold text-sm mb-2">State</p>

          <b-input placeholder="Enter  State..." />
        </div>
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Pin Code</p>
        <b-input placeholder="Enter  pincode..." />
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Served in Location City</p>

        <base-input class="div-mb-0">
          <select class="form-control ">
            <option disabled="true">Select</option>
            <option>Mumbai</option>
            <option>Gujrat</option>
          </select>
        </base-input>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Category</p>

        <base-input class="div-mb-0">
          <select class="form-control ">
            <option disabled="true">Select</option>
            <option>Furnitures</option>
            <option>Furnitures</option>
          </select>
        </base-input>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Sub-Categories</p>

        <base-input class="div-mb-0">
          <select class="form-control ">
            <option disabled="true">Select</option>
            <option>Table</option>
            <option>Chair</option>
          </select>
        </base-input>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Commission Type</p>

        <base-input class="div-mb-0">
          <select class="form-control ">
            <option disabled="true">Select</option>
            <option>Fixed (INR)</option>
            <option>Percentage</option>
          </select>
        </base-input>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Payment Details</p>

        <base-input class="div-mb-0">
          <select class="form-control ">
            <option disabled="true">Select</option>
            <option>Paypal</option>
            <option>Google Pay</option>
            <option>Internet Banking</option>
          </select>
        </base-input>
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Status</p>

        <base-input class="div-mb-0">
          <select class="form-control ">
            <option disabled="true">Select</option>
            <option>Approved</option>
            <option>Pending</option>
            <option>Disapproved</option>
          </select>
        </base-input>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Action</p>

        <base-input class="div-mb-0">
          <select class="form-control ">
            <option disabled="true">Select</option>
            <option>Edit</option>
            <option>Delete</option>
          </select>
        </base-input>
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Comment</p>
        <b-input placeholder="Enter  comment..." />
      </div>
    </div>
    <footer class="footer-fix fixed bottom-0	w-1/4 ">
      <base-button
        block
        type="primary"
        class="uppercase rounded-none font-semibold"
        >ADD</base-button
      >
    </footer>
  </side-bar>
</template>

<script>
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      value: ""
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    }
  }
};
</script>
